import {
  type FormRadioSelectionProps,
  FormRadioSelection,
  RadioButtonCheckedIcon,
  Flex,
  type FlexProps,
  mergeSx,
  type SvgIconProps,
} from '@shared/components';
import { type FieldValues } from 'react-hook-form';

import type { BaseInputModeProps } from '../../types';

type InputModeProps = BaseInputModeProps<Omit<FormRadioSelectionProps<FieldValues>, 'name'>>;

interface ViewModeProps {
  mode: 'view';
  value: JSX.Element;
  slotProps?: { wrapper?: FlexProps; icon?: SvgIconProps };
}

export type RadioSelectionRendererProps = InputModeProps | ViewModeProps;

export default function RadioSelectionRenderer(props: Readonly<RadioSelectionRendererProps>) {
  switch (props.mode) {
    case 'input': {
      const { name, slotProps: { options = [], ...slotProps } = {} } = props;
      return <FormRadioSelection name={name} options={options} {...slotProps} />;
    }
    case 'view': {
      const { value, slotProps } = props;
      const {
        wrapper: { sx: flexSx, ...flexProps } = {},
        icon: { sx: iconSx, ...iconProps } = {},
      } = slotProps || {};

      return (
        <Flex
          sx={mergeSx((theme) => ({ gap: theme.spacing(2), alignItems: 'center' }), flexSx)}
          {...flexProps}
        >
          <RadioButtonCheckedIcon
            sx={mergeSx(
              (theme) => ({ color: theme.palette.grey[500], cursor: 'not-allowed' }),
              iconSx,
            )}
            {...iconProps}
          />
          {value}
        </Flex>
      );
    }
  }
}
